// @file Composable for Google Drive
/// <reference types="@types/google.picker" />

export const useGoogleDrive = (): {
  requestGoogleDriveAuthorization: typeof requestGoogleDriveAuthorization
} => {
  const requestGoogleDriveAuthorization = async ({
    userId,
    tenantId,
  }: {
    userId: number
    tenantId: number
  }): Promise<{ email: string; token: string }> => {
    return await new Promise((resolve, reject) => {
      const googleOauthTokenResponseHandler = (result): void => {
        window.removeEventListener('google_drive_auth', googleOauthTokenResponseHandler)
        return resolve({ email: result.detail.email, token: result.detail.accessToken })
      }
      window.addEventListener('google_drive_auth', googleOauthTokenResponseHandler)
      const oauthPath = `/auth/google_oauth2?tenant_id=${tenantId}&scope_alias=drive&afterwards=dispatch_parent_drive`
      const oauthWindow = window.open(oauthPath, 'google_oauth', 'height=600,width=450')
      if (oauthWindow != null) {
        oauthWindow.focus()
      }
    })
  }

  return {
    requestGoogleDriveAuthorization,
  }
}
